import { GET_REPORTED_USER, DISMISS_USER_REPORT } from "./types";

const initialState = {
  reportedUser: [],
};

const ReportedUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_USER:
      return {
        ...state,
        reportedUser: action.payload,
      };
    case DISMISS_USER_REPORT:
      return {
        ...state,
        reportedUser: state.reportedUser.filter(
          (data) => data._id?._id !== action.payload.userId,
        ),
      };
    default:
      return state;
  }
};

export default ReportedUserReducer;
